var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicContentText = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
exports.TopicContentText = (props) => {
    if (props.data.hideText) {
        return null;
    }
    const topicOptions = props.topicOptions;
    const useAbstractElement = props.useAbstractElement || 'p';
    const useHeadingElement = props.useHeadingElement || 'h3';
    const AbstractParser = props.useAbstractParser || props.data.useAbstractParser || core_1.Any;
    const HeadingParser = props.useHeadingParser || props.data.useHeadingParser || core_1.Any;
    return (react_1.default.createElement(core_1.Box, { is: "div", wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.text }) },
        !topicOptions.hideIcon &&
            props.topic.icon &&
            !props.data.hideIcon &&
            (props.useIconElement ? (props.useIconElement) : (react_1.default.createElement(core_1.Icon, { customIconMap: props.data.customIconMap, icon: props.topic.icon || '', wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.icon }) }))),
        !topicOptions.hideHeading &&
            props.topic.heading &&
            !props.data.hideHeading && (react_1.default.createElement(HeadingParser, { polyPreset: true, is: useHeadingElement, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.heading }) }, props.topic.heading)),
        !topicOptions.hideAbstract &&
            props.topic.abstract &&
            props.topic.abstract.abstract &&
            !props.data.hideAbstract && (react_1.default.createElement(AbstractParser, { polyPreset: true, is: useAbstractElement, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.abstract }) }, props.topic.abstract.abstract))));
};
//# sourceMappingURL=topic-content-text.js.map